import { divIcon } from "leaflet";
import { H4 } from "../../AbstractElements";

export const AgentColumns = ( ActionCell ) => {
    return [
        {
            name: <H4>Sl.No</H4>,
            selector: row => row.Si,
            width: '70px',
            center: true,
        },
        {
            name: <i className="fa fa-gears" style={{ fontSize: '20px' }}></i>,
            selector: row => row.action,
            cell: row => <ActionCell row={row} />,
            center: true,
            width: '70px',

        },
        {
            name: <H4>Name</H4>,
            id: 'name',
            selector: row => row.Name,
            sortable: true,
        },
        {
            name: <H4>Role</H4>,
            id: 'role_name',
            selector: row => row.role,
            sortable: true,
            wrap: true
        },
        {
            name: <H4>Shift</H4>,
            id: 'mobile',
            selector: row => row.shift,
            sortable: true,
        },

        {
            name: <H4>Today</H4>,
            id: 'tody',
            selector: row =>
                <div>

                    <div className={`${row.leave === 'Absent' ? 'badge-lost' : 'badge-approved'}`}>{row.leave}</div>
                </div>,
            sortable: true,
        },
        // {
        //     name: <H4>Leave </H4>,
        //     selector: row => row.Status,
        //     // cell: row => (
        //     //     <span
        //     //         className={`badge badge-${row.Status}`}
        //     //     >
        //     //         {row.Status.charAt(0).toUpperCase() + row.Status.slice(1).replace('_', ' ')}
        //     //     </span>
        //     // ),
        // },
        {
            name: <H4>Geofence Zone</H4>,
            id: 'geofence_zone',
            selector: row => row.zone,
            sortable: true,
        },
        {
            name: <H4>Leave Bal.</H4>,
            id: 'stock_enabled',
            selector: row => row.enableStock,
            sortable: true,
        },
    ];
}
export const shiftColumns = [
    {
        name: <H4>Sl.No</H4>,
        selector: row => row.Si,
        width: '70px',
        center: true,
    },
    // {
    //     name: <i className="fa fa-gears" style={{ fontSize: '20px' }}></i>,
    //     selector: row => row.action,
    //     cell: row => <ActionCell row={row} />,
    //     center: true,
    //     width: '70px',

    // },
    {
        name: <H4>Name</H4>,
        id: 'name',
        selector: row => row.Name,
        sortable: true,
    },
    {
        name: <H4>	Department</H4>,
        id: 'email',
        selector: row => row.Email,
        sortable: true,
        wrap: true
    },
    {
        name: <H4>Shift</H4>,
        id: 'mobile',
        selector: row => row.Mobile,
        sortable: true,
    },
    {
        name: <H4>Employment</H4>,
        id: 'role',
        selector: row => row.Roles,
        sortable: true,
    },
    {
        name: <H4>Today</H4>,
        id: 'stock_enabled',
        selector: row => row.enableStock,
        sortable: true,
    },
    {
        name: <H4>Leave </H4>,
        selector: row => row.Status,
        cell: row => (
            <span
                className={`badge badge-${row.Status}`}
            >
                {row.Status.charAt(0).toUpperCase() + row.Status.slice(1).replace('_', ' ')}
            </span>
        ),
    },
    {
        name: <H4>Leave Bal.</H4>,
        id: 'stock_enabled',
        selector: row => row.enableStock,
        sortable: true,
    },
];
